// ENVIRONMENT
const ENV = import.meta.env.VITE_ENV;
const IS_DEVELOPMENT = ENV === 'development' && import.meta.env.VITE_RPC_TARGET !== 'mainnet';
const BACKEND_API_URL = import.meta.env.VITE_BACKEND_API_URL;

// WALLET CONNECT
const PROJECTID = import.meta.env.VITE_WALLETCONNECT_PROJECT_ID;
const APPNAME = import.meta.env.VITE_APP_NAME;

// SOCKET URL
const SOCKET_URL = import.meta.env.VITE_BACKEND_SOCKET_URL;

// ETHERSCAN API
const ETHERSCAN_API = import.meta.env.VITE_ETHERSCAN_API;

// SAHAL PIN
const SAHAL_PIN = import.meta.env.VITE_SAHAL_PIN;

// ETHERSCAN
const ETHERSCAN_ENDPOINT = import.meta.env.VITE_ETHERSCAN_ENDPOINT;

export const config = {
  isDevelopment: IS_DEVELOPMENT,
  environment: ENV,
  baseUrl: BACKEND_API_URL,
  projectId: PROJECTID,
  appName: APPNAME,
  socketUrl: SOCKET_URL,
  etherscanApi: ETHERSCAN_API,
  sahalPin: SAHAL_PIN,
  etherscanEndPoint: ETHERSCAN_ENDPOINT,
};
